export const REQUEST_YOUR_MEETING = "request_your_meeting"
export const YOUR_MEETING_SUCCESS = "your_meeting_success"
export const YOUR_MEETING_FAILURE = "your_meeting_failure"
export const INSERTING_MEETING_IN_YOUR_MEETING = "inserting_meeting_in_your_meeting"

export const CLEAR_YOUR_MEETING_STATE = "clear_your_meeting_state"